// Vendor
import { ElementRef } from '@angular/core';
// Services
import { HoldingsOverlapService } from '../../services/holdings-overlap.service';
import { downloadUrl } from 'NewAngular/utils/download';
// Constants
import { ALL_HOLDINGS, INTERSECT_UNIQUE_HOLDINGS } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { INVESTED_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { LEGACY_QUOTE_PAGE_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/holdings-overlap.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i7 from "@angular/common";
import * as i8 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i9 from "../holdings-comparison-table/holdings-comparison-table.component";
import * as i10 from "../top-holdings/top-holdings.component";
import * as i11 from "SecuritiesApp/ts/features/holdings-overlap/components/sector-exposure-comparison/sector-exposure-comparison.component";
import * as i12 from "SecuritiesApp/ts/features/holdings-overlap/components/common-holdings-comparison/common-holdings-comparison.component";
const _c0 = a0 => ({ disabled: a0 });
const _c1 = (a0, a1) => [a0, a1];
function HoldingsOverlapComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵlistener("click", function HoldingsOverlapComponent_div_11_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetSecondarySecurity()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.secondarySecurity.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
} }
function HoldingsOverlapComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", "As of " + ctx_r1.secondaryAsOfDate);
} }
function HoldingsOverlapComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "label", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function HoldingsOverlapComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1, "Get started.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Add a second security above.");
    i0.ɵɵelementEnd()();
} }
function HoldingsOverlapComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 21)(2, "div", 22)(3, "h3", 23);
    i0.ɵɵtext(4, "Overlap Key Stats");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 24)(6, "table", 25)(7, "tbody")(8, "tr")(9, "th");
    i0.ɵɵtext(10, "Overlap by Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "# of Overlapping Holdings");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "th", 16)(14, "th", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "tr")(16, "td");
    i0.ɵɵelement(17, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵelement(19, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵelement(21, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵelement(23, "span", 26);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelement(24, "ycn-sector-exposure-comparison", 27)(25, "ycn-common-holdings-comparison-table", 28);
    i0.ɵɵelementStart(26, "div", 29)(27, "div", 30);
    i0.ɵɵelement(28, "ycn-holdings-comparison-table", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 30);
    i0.ɵɵelement(30, "ycn-holdings-comparison-table", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 29)(32, "div", 30);
    i0.ɵɵelement(33, "ycn-top-holdings", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 30);
    i0.ɵɵelement(35, "ycn-top-holdings", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("textContent", "% of " + ctx_r1.primarySecurityName + "'s holdings also in " + ctx_r1.secondarySecurityName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", "% of " + ctx_r1.secondarySecurityName + "'s holdings also in " + ctx_r1.primarySecurityName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.overlap_by_weight);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.overlap_holdings_count);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.primary_shared_holdings_percentage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.secondary_shared_holdings_percentage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("exposureData", ctx_r1.overlapMetrics.exposure_data)("sectorChartData", ctx_r1.overlapMetrics.sector_chart_data);
    i0.ɵɵadvance();
    i0.ɵɵproperty("primarySecurityId", ctx_r1.primarySecurityId)("primaryDisplaySecurityId", ctx_r1.primarySecurityDisplaySecurityId)("secondarySecurityId", ctx_r1.secondarySecurity.securityId)("secondaryDisplaySecurityId", ctx_r1.secondarySecurity.displaySecurityId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.holdingsType)("title", ctx_r1.primaryRelatedSecurity.name + " Unique Holdings")("comparable", ctx_r1.primaryRelatedSecurity)("disableRemoveFromMenu", true)("intersectOption", ctx_r1.holdingsIntersectionOption)("comparableSecurities", i0.ɵɵpureFunction2(34, _c1, ctx_r1.primaryRelatedSecurity, ctx_r1.secondarySecurity))("holdingsLayer", ctx_r1.holdingsLayer)("showNoHoldingsMessage", true)("showHoldingsDate", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.holdingsType)("title", ctx_r1.secondarySecurity.name + " Unique Holdings")("comparable", ctx_r1.secondarySecurity)("disableRemoveFromMenu", true)("intersectOption", ctx_r1.holdingsIntersectionOption)("comparableSecurities", i0.ɵɵpureFunction2(37, _c1, ctx_r1.secondarySecurity, ctx_r1.primaryRelatedSecurity))("holdingsLayer", ctx_r1.holdingsLayer)("showNoHoldingsMessage", true)("showHoldingsDate", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("securityId", ctx_r1.primarySecurityId)("displaySecurityId", ctx_r1.primarySecurityDisplaySecurityId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("securityId", ctx_r1.secondarySecurity.securityId)("displaySecurityId", ctx_r1.secondarySecurity.displaySecurityId);
} }
/**
 * HoldingsOverlapComponent.
 *
 * Component reperesenting the Holdings Overlap tab.
 */
export class HoldingsOverlapComponent {
    constructor(el, holdingsOverlapService, accountsService, featureService) {
        this.el = el;
        this.holdingsOverlapService = holdingsOverlapService;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.secondarySecurityName = '';
        this.loading = false;
        this.overlapDataLoaded = false;
        this.overlapMetrics = null;
        this.errorMessage = '';
        this.holdingsType = ALL_HOLDINGS;
        this.holdingsIntersectionOption = INTERSECT_UNIQUE_HOLDINGS;
        this.holdingsLayer = INVESTED_HOLDINGS;
        this.primaryAsOfDate = '';
        this.secondaryAsOfDate = '';
        this.viewingGenericData = false;
        this.primarySecurityName = el.nativeElement.getAttribute('primarySecurityName');
        this.primarySecurityId = el.nativeElement.getAttribute('primarySecurityId');
        this.primaryAsOfDate = el.nativeElement.getAttribute('primaryAsOfDate');
        this.primarySecurityType = el.nativeElement.getAttribute('primarySecurityType');
        this.primarySecurityUrl = el.nativeElement.getAttribute('primarySecurityUrl');
        this.primarySecurityDisplaySecurityId = el.nativeElement.getAttribute('primarySecurityDisplaySecurityId');
        this.primaryRelatedSecurity = {
            name: this.primarySecurityName,
            securityId: this.primarySecurityId,
            securityType: this.primarySecurityType,
            url: this.primarySecurityUrl,
            displaySecurityId: this.primarySecurityDisplaySecurityId,
        };
    }
    ngOnInit() {
        this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericDataDisplay) => {
            this.viewingGenericData = useGenericDataDisplay;
        });
    }
    fetchOverlapData() {
        this.loading = true;
        this.holdingsOverlapService
            .getOverlapKeyStats(this.primarySecurityId, this.secondarySecurity.securityId)
            .subscribe({
            next: (stats) => {
                this.loading = false;
                this.overlapDataLoaded = true;
                this.overlapMetrics = stats;
                this.errorMessage = '';
                this.secondaryAsOfDate = stats.secondary_as_of_date;
            },
            error: (response) => {
                this.loading = false;
                if (response.error) {
                    this.errorMessage = response.error;
                }
                else {
                    this.errorMessage = 'An error has occurred. Please try again or contact support.';
                }
            },
        });
    }
    exportPDF() {
        this.errorMessage = '';
        const url = this.holdingsOverlapService.getHoldingsOverlapPDFExportUrl(this.primarySecurityId, this.secondarySecurity.securityId);
        if (this.viewingGenericData || this.featureService.userHasFeatures(['exportLegacyData'])) {
            downloadUrl(url);
        }
        else {
            this.errorMessage = 'Unable to generate overlap report';
        }
    }
    secondarySecuritySelectionHandler(securityObject) {
        if (!securityObject)
            return;
        this.secondarySecurity = {
            displaySecurityId: securityObject.display_security_id,
            name: securityObject.name,
            securityId: securityObject.search_id,
            securityType: securityObject.type,
            url: securityObject.url,
        };
        this.secondarySecurityName = this.secondarySecurity.name;
        this.fetchOverlapData();
    }
    resetSecondarySecurity() {
        this.secondarySecurity = undefined;
        this.overlapDataLoaded = false;
        this.errorMessage = '';
    }
}
HoldingsOverlapComponent.ɵfac = function HoldingsOverlapComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverlapComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HoldingsOverlapService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.FeatureService)); };
HoldingsOverlapComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsOverlapComponent, selectors: [["ycn-holdings-overlap"]], inputs: { primarySecurityName: "primarySecurityName", primarySecurityId: "primarySecurityId", primarySecurityUrl: "primarySecurityUrl", primarySecurityType: "primarySecurityType", primarySecurityDisplaySecurityId: "primarySecurityDisplaySecurityId" }, standalone: false, decls: 21, vars: 14, consts: [[1, "d-flex", "align-items-baseline", "mb-row"], [1, "d-flex", "align-items-baseline", "mr-20"], [1, "form-label", "form-label-thin", "text-nowrap", "mr-1"], [1, "d-flex", "align-items-center", "min-height-base", 3, "textContent"], [1, "text-smallest", "text-gray-40", 3, "textContent"], [1, "form-group-editable"], ["class", "form-value", 4, "ngIf"], ["class", "text-smallest text-gray-40", 3, "textContent", 4, "ngIf"], [3, "submitHandler", "hidden", "searchType"], ["class", "d-flex align-items-baseline mr-20", 4, "ngIf"], [1, "ml-auto"], [1, "btn", "btn-secondary", "text-nowrap", 3, "click", "ngClass", "disabled"], ["class", "get-started border-0 pt-100", 4, "ngIf"], [4, "ngIf"], ["loaderMessage", "Loading Data...", 3, "hidden"], [1, "form-value"], [3, "textContent"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "form-label", "text-red", 3, "textContent"], [1, "get-started", "border-0", "pt-100"], ["data-test-id", "overlap-key-stats", 1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-content"], [1, "key-stats-table"], [1, "key-stat-title", 3, "textContent"], ["data-test-id", "sector-exposure-comparison-chart", 3, "exposureData", "sectorChartData"], ["data-test-id", "common-holdings-comparison-table", 3, "primarySecurityId", "primaryDisplaySecurityId", "secondarySecurityId", "secondaryDisplaySecurityId"], [1, "row"], [1, "col-6"], [3, "type", "title", "comparable", "disableRemoveFromMenu", "intersectOption", "comparableSecurities", "holdingsLayer", "showNoHoldingsMessage", "showHoldingsDate"], ["data-test-id", "primary-top-holdings", 3, "securityId", "displaySecurityId"], ["data-test-id", "secondary-top-holdings", 3, "securityId", "displaySecurityId"]], template: function HoldingsOverlapComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3, "Security 1:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵelement(5, "div", 3)(6, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 1)(8, "label", 2);
        i0.ɵɵtext(9, "Security 2:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵtemplate(11, HoldingsOverlapComponent_div_11_Template, 4, 3, "div", 6)(12, HoldingsOverlapComponent_div_12_Template, 1, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "ycn-add-button-autocomplete", 8);
        i0.ɵɵlistener("submitHandler", function HoldingsOverlapComponent_Template_ycn_add_button_autocomplete_submitHandler_13_listener($event) { return ctx.secondarySecuritySelectionHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, HoldingsOverlapComponent_div_14_Template, 2, 1, "div", 9);
        i0.ɵɵelementStart(15, "div", 10)(16, "button", 11);
        i0.ɵɵlistener("click", function HoldingsOverlapComponent_Template_button_click_16_listener() { return ctx.exportPDF(); });
        i0.ɵɵtext(17, "Export PDF");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(18, HoldingsOverlapComponent_div_18_Template, 5, 0, "div", 12)(19, HoldingsOverlapComponent_div_19_Template, 36, 40, "div", 13);
        i0.ɵɵelement(20, "ycn-loading-symbol", 14);
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.primarySecurityName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", "As of " + ctx.primaryAsOfDate);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.secondarySecurity)("searchType", "securities_with_holdings");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, !ctx.overlapDataLoaded))("disabled", !ctx.overlapDataLoaded);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.overlapDataLoaded);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.loading);
    } }, dependencies: [i4.LoadingSymbolComponent, i5.IconDirective, i6.AddButtonAutocompleteComponent, i7.NgClass, i7.NgIf, i8.TooltipDirective, i9.HoldingsComparisonTableComponent, i10.TopHoldingsComponent, i11.SectorExposureComparisonChart, i12.CommonHoldingsComparisonTableComponent], encapsulation: 2 });
